/**
 * Narrowing helpers for values that arrived as `unknown`.
 *
 * `isRecord` existed five times in this app — in `formatActivity.ts`,
 * `MessageBodyView.tsx`, `draftStorage.ts`, `useRealtime.ts` and
 * `formatNotification.ts` — byte-identical every time. None of the copies were
 * wrong, which is the point: five right answers to the same question is still
 * four more definitions than the question has.
 *
 * The `!Array.isArray` clause is the part worth having in one place. `typeof []
 * === 'object'` and `[] !== null`, so without it an array passes as a record
 * and every `value['key']` read afterwards silently yields undefined.
 */

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** A non-empty string, which is what most "did the server send this" checks mean. */
export function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0;
}
